import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery, Grid, Button, Typography } from '@material-ui/core';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';
import {Box} from '@material-ui/core'

const useStyles = makeStyles(theme => ({

    font:{
        fontSize:'18px'
    },
  image: {
    boxShadow:
      '25px 60px 125px -25px rgba(80,102,144,.1), 16px 40px 75px -40px rgba(0,0,0,.2)',
    borderRadius: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
    },
  },
}));

const Work= props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box  className={className} {...rest} marginBottom={2} marginLeft= {2} marginRight={2} marginTop= {2} display="flex" justifyContent="space-evenly" alignItems="center" padding={6} border="1px solid #ccc" borderRadius="4px">
      <Grid
        container
        justify="space-between"
        spacing={4}
        direction={isMd ? 'row' : 'column-reverse'}
      >
        <Grid
          item
          container
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <SectionHeader
            title={
              <span>
        ASKION C-line® 
                <br />
                <Typography component="span" variant="inherit" color="primary">
          Work Bench
                </Typography>
              </span>
            }
          
            align="left"
            disableGutter
            titleVariant="h3"

            />
            <ul className = {classes.font}>
                <li>
                Deep-cold working room with adjustable temperature up to -110 ° C.
                </li>

                <li>
                Up to three independent freezers.

                </li>
                <li>
            Freely configurable freezing curves.
                </li>
                <li>
            	Sample format independent.

                </li>
                <li>
            Temperature reference measurement (including sample sensor).


                </li>

                <li>
            Regulated seeding (targeted release of crystallization).

                </li>

                <li>
                Electrically height adjustable.

                </li>

                <li>
            	Internal / external barcode scanner.

                </li>

                <li>
            Continuous cold chain.
                </li>

                <li>
            	Panel PC with touch screen.
                </li>
                <li>
                Software and hardware supported monitoring system.

                </li>

                <li>
            Configurable software interface to external programs, eg. B. LIMS / HIS

                </li>
               
            </ul>

            <SectionHeader
            ctaGroup={[
              <Button variant="contained" color="primary" size="large">
                Quickbook
              </Button>,
              <Button variant="outlined" color="primary" size="large">
              Talk to us
              </Button>,
            ]}
            align="left"
            disableGutter
            titleVariant="h3"
          />
        </Grid>
        <Grid
          item
          container
          justify="flex-start"
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <Image
            src="https://onwhicar.sirv.com/premas/main/askion/cline-coldeye.png"
            alt="Workbench"
            className={classes.image}
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

Work.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Work;
